import useApiQuery from '../useApiQuery';
import keys from './keys';

/***
 * This hook returns all the show Plus data from pegasus
 * including non active tiers like archived and draft.
 * We advise to not use this hook directly and fetch
 * this data through the hook useAcastPlus.
 */

const useGetPlusData = (hasUserAccess, showId) => {
  const query = useApiQuery({
    requestUrl: `/plus/shows/${showId}`,
    disabled: !hasUserAccess || !showId,
    queryKey: keys(showId).acastPlus,
  });

  return {
    show: query.data?.show?.data,
    tiers: query.data?.show?.data?.tiers,
    hasPegasusError: query.error,
    hasPegasusFetchError: query.isError,
    hasPegasusFetchSuccess: query.isSuccess,
    hasPegasusFetching: query.isFetching,
    hasPegasusLoading: query.isInitialLoading,
    ...query,
  };
};

export default useGetPlusData;
